import { KeyValue } from '@/main/models/common';
import {
  ApprovalMatrixTypeTypes,
  ApprovalMatrixTypeActionTypes
} from './approvalMatrixTypeTypes';

export function getApprovalMatrixType(): ApprovalMatrixTypeActionTypes {
  return {
    type: ApprovalMatrixTypeTypes.GET_APPROVAL_MATRIX_TYPE
  };
}

export function saveApprovalMatrixType(
  data: KeyValue[] | null,
  isError: boolean,
  errorMessages: string[] | null
): ApprovalMatrixTypeActionTypes {
  return {
    type: ApprovalMatrixTypeTypes.SAVE_APPROVAL_MATRIX_TYPE,
    payload: {
      data,
      isError,
      errorMessages
    }
  };
}

export function resetReducerApprovalMatrixType(): ApprovalMatrixTypeActionTypes {
  return {
    type: ApprovalMatrixTypeTypes.RESET_REDUCER_APPROVAL_MATRIX_TYPE
  };
}